<div class="container py-4">
  <h2>Cotización</h2>

  <div *ngIf="!q.items().length" class="alert alert-info mt-3">
    No has agregado ítems a cotizar.
  </div>

  <ul class="list-group my-3" *ngIf="q.items().length">
    <li class="list-group-item d-flex justify-content-between align-items-center"
        *ngFor="let it of q.items()">
      <span>{{ it.product.name }}</span>
      <button class="btn btn-sm btn-outline-danger" (click)="q.remove(it.product.id)">Quitar</button>
    </li>
  </ul>

  <form class="row g-3">
    <div class="col-md-6">
      <label class="form-label small">Empresa/Nombre</label>
      <input class="form-control" placeholder="Hospital, clínica o persona natural">
    </div>
    <div class="col-md-6">
      <label class="form-label small">Correo</label>
      <input type="email" class="form-control" placeholder="correo@dominio.com">
    </div>
    <div class="col-12">
      <label class="form-label small">Comentarios</label>
      <textarea class="form-control" rows="4" placeholder="Requerimientos, cantidades, plazos, destino..."></textarea>
    </div>
    <div class="col-12 d-flex gap-2">
      <button class="btn btn-primary" type="button">Enviar solicitud</button>
      <button class="btn btn-outline-secondary" type="button" (click)="q.clear()">Limpiar</button>
    </div>
  </form>
</div>
